import { useState, useEffect } from 'react';
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import Lazyload from 'react-lazy-load'
import {Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';
import { useLocation } from '@reach/router';

const HealthFitnessAnalytics = () => {
    const location = useLocation();
    const { pathname } = location;
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 soln-hero hfa-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h1 className="font-weight-semibold hero-heading text-center">
                        <Trans>Data-Driven Wellness</Trans>
                    </h1>
                    <p className="hero-para font-weight-normal text-center">
                        <Trans>Track, analyze and improve employee health metrics with comprehensive insights.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section className="position-relative pb-0 vfitsoln hf-2">
            <div className="feat_box sect-white-col-2 shadow feat_pb0 mb-0">
                <div className="d-flex m-d-block justify-content-between align-items-center container custom_container p0">
                    <div className="col-12 col-md-6 p-0">
                        <div className="col-12 p-0">
                            <h2 className='font-weight-semibold py-2 section-heading green-text'><Trans>Need a <span>centralized platform</span> to monitor employee wellness?</Trans></h2>
                            <p className='section-para font-weight-normal'><Trans>Vantage Fit offers a unified dashboard, <br/>providing a holistic view of your <br/>organization's health metrics.</Trans></p>
                        </div>
                    </div>
                    <div className='cta-img'>
                        <div className='d-flex floatimg'>
                            <img loading="lazy" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1698815134/VantageFit/2023/Health-fitness-analytics-painpoint.webp`)} alt="Need a centralized platform to monitor employee wellness?" width="1001" height="636"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <h2 className="section-heading section-heading-top font-weight-semibold text-center"><Trans>Reconnect with All-Encompassing Health Insights.</Trans></h2>
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>All-in-One Wellness Dashboard</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Track health metrics and participation seamlessly to boost Engagement and well-being.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                        <p className='text-white'><Trans>Track health metrics and participation effortlessly in an all-in-one dashboard.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Enhance user engagement and well-being through easy-to-use wellness tracking.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide a complete view of health metrics for a well-rounded well-being experience.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703072625/VantageFit/2023/Health-fitness-analytics-All-in-One_Wellness_Dashboard.webp`)} loading='lazy' alt="All-in-One Wellness Dashboard" width="550" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Empower HR</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Dive into employee health metrics and garner in-depth insights for enhanced well-being.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                        <p className='text-white'><Trans>Empower HR with detailed employee health metrics for comprehensive well-being insights.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Dive deep into health data to gather in-depth insights and support employee wellness effectively.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide HR with the tools to drive employee well-being through informed analysis.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703072631/VantageFit/2023/Health-Fitness-Analytics-EmpowerHR.webp`)} loading='lazy' alt="Empower HR" width="644" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Nutrition and Calorie Tracker</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Log meals and monitor food entries for tailored health insights  and optimized well-being.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                        <p className='text-white'><Trans>Encourage your team to record meals and track food entries, gaining personalized health insights.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Assist them in monitoring calorie intake for optimized well-being and nutrition.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Unlock customized insights by tracking nutrition for an enhanced well-being experience.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703072642/VantageFit/2023/Health-fitness-analytics-Nutrition_and_Calorie_Tracker.webp`)} loading='lazy' alt="Nutrition and Calorie Tracker" width="525" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>The Physical Wellness Suite</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Harness the power of movement with analytics to fuel your fitness journey.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                        <p className='text-white'><Trans>Utilize powerful analytics to enhance your fitness journey.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Harness the power of movement through a comprehensive physical wellness suite.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1698815139/VantageFit/2023/Health-fitness-analytics-The_Physical_Wellness_Suite.webp`)} loading='lazy' alt="The Physical Wellness Suite" width="540" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="gray-gradient-bg section-pdn-1">
            <div className="container custom_container mx-auto relative">
                <div className="px-5">
                    <h2 className="section-heading text-center pt-0">
                    <Trans>Real people, real results</Trans>
                    </h2>
                    <p className="col-12 sub-para text-center f-400 mt-0 mb-5 pb-5">
                    <Trans>Vantage Fit speaks for itself, but our
                        customer reviews speak even louder.</Trans>
                    </p>
                    {/* <div className="col-lg-12 testimonialcarousel mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1701422593/VantageFit/2023/vfit-default-gravatar_1_1.png" alt="romod Patil" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Promod Patil</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0">KEVA</p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0">The fact that our employees could easily download the application and access all the minute details about the Fit-o-meter challenge on their phones motivated them to participate in the program. Vantage Fit app helped us to create higher engagement levels among our employees.</p>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-12 testimonialcarousel d-none d-md-flex mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700137313/VantageFit/2023/vfit-default-gravatar_1_1.png" alt="Promod Patil" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Promod Patil</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0">KEVA</p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0"><Trans>The fact that our employees could easily download the application and access all the minute details about the Fit-o-meter challenge on their phones motivated them to participate in the program. Vantage Fit app helped us to create higher engagement levels among our employees.</Trans></p>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none d-block p-3" style={{ background: 'white', boxShadow: '1px 0px 20px rgba(0,0,0,0.3)', borderRadius: '25px' }}>
                        <div className="p-2" style={{ background: '#1d2227', borderRadius: '40px' }}>
                            <img style={{ marginLeft: '0.5rem !important', marginTop: '0.5rem', marginBottom: '1rem', display: 'grid', justifyContent: 'center' }} src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/vfit-default-gravatar_1_1.png" alt="Promod Patil" className="mx-auto" width="218" height="218" loading="lazy"/>
                            <h3 className="font-weight-bold text-center text-white mb-0">Promod Patil</h3>
                            <p className="font-weight-light text-center text-white my-3">KEVA</p>
                        </div>
                        <p className="section-para text-center text-lg-left my-4"><Trans>The fact that our employees could easily download the application and access all the minute details about the Fit-o-meter challenge on their phones motivated them to participate in the program. Vantage Fit app helped us to create higher engagement levels among our employees.</Trans></p>

                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative section-pdn-1 pl-0 pr-0 faq-wrapper">
            <div className="logo-container">
                <h2 className="section-heading mb-5 no-br clr49 font-weight-bold">FAQ</h2>
                <div id="accordion" className="">
                    <Card>
                        <Button id="faq1">
                        <Trans>Can we view our complete fitness analytics in Vantage Fit?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq1">
                            <CardBody>
                            <Trans>Vantage Fit offers comprehensive employee fitness analytics to monitor and assess their fitness status.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq2">
                        <Trans>Can we download the analytics reports in Vantage Fit?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq2">
                            <CardBody>
                            <Trans>Analytics and insights are accessible to the admins and can be downloaded by the admins.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq3">
                        <Trans>What types of analytics are available in Vantage Fit?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq3">
                            <CardBody>
                            <Trans>Vantage Fit provides admins with the capability to monitor their organization's fitness analytics by offering various report categories, including engagement, health, wellness, and more.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                </div>
            </div>
        </section>

        <section className="hfa-btm ctabtm multi-activity hero-bg position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center">
                        <Trans>Empower Your Wellness Decisions with Data!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5">
                        <Trans>Optimize employee health with Vantage Fit's comprehensive analytics.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default HealthFitnessAnalytics
